import { parseString } from "xml2js";

export default function getAddressByCEP(cep, urlWsdl, method = "POST") {
  return new Promise((resolve, reject) => {
    if (isCEP(cep)) {
      const xhr = createCORSRequest(method, urlWsdl);

      if (xhr) {
        const bodyXML = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:hs="http://cliente.bean.master.sigep.bsb.correios.com.br/">
        <soapenv:Body>
        <hs:consultaCEP>
        <cep>${cep}</cep>
        </hs:consultaCEP>
        </soapenv:Body>
        </soapenv:Envelope>`;

        xhr.onload = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            try {
              const address = xmlToObject(xhr.responseText);

              if (!address) {
                reject(
                  Error("Nenhum endereço encontrado com o CEP informado.")
                );
              } else {
                resolve(address);
              }
            } catch (error) {
              reject(error);
            }
          } else {
            reject(Error("Occurred a error in the request."));
          }
        };

        xhr.setRequestHeader("Content-Type", "text/xml");
        xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
        xhr.setRequestHeader("Access-Control-Allow-Methods", "POST");
        xhr.setRequestHeader("mode", "no-cors");
        xhr.send(bodyXML);
      } else {
        reject(Error("Impossivel carregar a resposta do servidor."));
      }
    } else {
      reject(Error("CEP é Invalido!"));
    }
  });
}

function createCORSRequest(method, url) {
  let xhr = new XMLHttpRequest();

  if ("withCredentials" in xhr) {
    xhr.open(method, url, true);
  } else if (typeof XDomainRequest != "undefined") {
    xhr = new XDomainRequest();
    xhr.open(method, url);
  } else {
    xhr = null;
  }

  return xhr;
}

function isCEP(cep) {
  cep = cep.trim();
  cep = cep.replace(/[.-]/g, "");

  return cep.length === 8 && /^[0-9]{8}$/.test(cep);
}

function xmlToObject(xml) {
  let address = null;

  parseString(xml, (error, result) => {
    if (result) {
      const responseCep =
        result["soap:Envelope"]["soap:Body"][0]["ns2:consultaCEPResponse"];

      if (responseCep.length > 0 && responseCep[0].hasOwnProperty("return")) {
        const returnXml = responseCep[0]["return"][0];

        address = {
          bairro: returnXml.bairro[0],
          cep: returnXml.cep[0],
          cidade: returnXml.cidade[0],
          complemento: returnXml.complemento2[0],
          logradouro: returnXml.end[0],
          uf: returnXml.uf[0]
        };
      }
    } else {
      throw Error("Error in parser xml to object.");
    }
  });

  return address;
}



// WEBPACK FOOTER //
// ./src/helpers/SoapCep.js